import { ERROR_CODES } from '@/model/ERROR_CODES'

export interface ResponseErrorMap {
  name: ERROR_CODES | undefined
  password: ERROR_CODES | undefined
  mail: ERROR_CODES | undefined
  major: ERROR_CODES | undefined
}

export function handleResponse(response: GD_userRegistration.RegisterResponse) {
  return new Promise((res, err) => {
    const errorMap: ResponseErrorMap = {
      name: undefined,
      password: undefined,
      mail: undefined,
      major: undefined,
    }

    if (response.registrationSuccessfull) {
      res(response)
      return
    }

    // major problems
    if (response.unknownError) {
      errorMap.major = ERROR_CODES.nameErrorUnknown
    }

    //name problems
    if (response.commonNameBlacklisted) {
      errorMap.name = ERROR_CODES.nameBlacklisted
    } else if (response.commonNameContainsIllegalChars || response.commonNameInvalidFormat) {
      errorMap.name = ERROR_CODES.nameInvalid
    } else if (response.commonNameInUse) {
      errorMap.name = ERROR_CODES.nameInuse
    }

    //mail problems
    if (response.emailDomainBlacklisted) {
      errorMap.mail = ERROR_CODES.mailBlacklisted
    } else if (response.emailInUse) {
      errorMap.mail = ERROR_CODES.mailInuse
    } else if (response.emailInvalid) {
      errorMap.mail = ERROR_CODES.mailInvalid
    }

    // password problems
    if (response.passwordInvalidFormat) {
      errorMap.password = ERROR_CODES.passInvalid
    } else if (response.passwordEqualsCommonName) {
      errorMap.password = ERROR_CODES.passEqualsName
    } else if (response.passwordEqualsEmail) {
      errorMap.password = ERROR_CODES.passwordEqualsEmail
    } else if (response.passwordWeak) {
      errorMap.password = ERROR_CODES.passWeak
    }

    err(errorMap)
  })
}
